import React, { useContext, useState, useEffect, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import './index.css'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import CommonContext from '../../../context/common/commonContext'
import ProductContext from '../../../context/product/productContext'
import { dateTimeFormatFunction } from '../../../common/components'
import { apiCall } from '../../../common/api'
import AlertContext from '../../../context/alert/alertContext'
import { Button } from '@material-ui/core'

const useStyles = makeStyles((theme, maxWidth) => ({
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%',
        maxWidth: '55rem',
    },
}))
const isOutlet = window?.location?.href?.includes('outlet')
const BidHistory = (props) => {
    const classes = useStyles()
    const [bidPopUp, setBidPopUp] = React.useState({
        popup: false,
        id: 0,
    })
    let [viewProduct, setViewProduct] = useState([])

    const commonContext = useContext(CommonContext)
    const productContext = useContext(ProductContext)
    const alertContext = useContext(AlertContext)
    const { bidHistoryValue, clearBidHistoryValue, phrase } = commonContext
    const { get_allbidhistory, getAllBidHistory } = productContext
    const { setAlert } = alertContext
    const [user] = useState(props.user)
    const [search, setSearch] = useState({
        limit: 10,
        page: 1,
        id: 0,
    })
    useEffect(() => {
        if (bidHistoryValue) {
            setSearch((prev) => ({ ...prev, id: bidHistoryValue, page: 1 }))
            setBidPopUp({ popup: true, id: bidHistoryValue })
            clearBidHistoryValue()
        }
    }, [bidHistoryValue])

    useEffect(() => {
        if (search.id !== 0) {
            getAllBidHistory(search)
        }
    }, [search])

    useEffect(() => {
        setViewProduct(get_allbidhistory.records.length ? get_allbidhistory.records : [])
    }, [get_allbidhistory])

    const customerMap = useMemo(() => {
        const currentUserId = parseInt(user?.id || 0, 10)
        const participants = new Map()
        let customerNo = 1

        viewProduct.forEach((row, index) => {
            const rowUserId = parseInt(row?.user_id || 0, 10)
            if (currentUserId && rowUserId === currentUserId) return

            const key =
                rowUserId > 0
                    ? `user-${rowUserId}`
                    : `name-${row?.namesec || row?.name || `row-${index}`}`

            if (!participants.has(key)) {
                participants.set(key, customerNo)
                customerNo += 1
            }
        })

        return participants
    }, [viewProduct, user?.id])

    const showDownloadButton = viewProduct.length > 0

    const getBidderLabel = (data, index) => {
        const currentUserId = parseInt(user?.id || 0, 10)
        const rowUserId = parseInt(data?.user_id || 0, 10)
        const isCurrentUserBid = currentUserId > 0 && rowUserId === currentUserId

        if (isCurrentUserBid) {
            return data?.name || data?.namesec || 'You'
        }

        if (data?.user_index) return `Customer ${data.user_index}`

        const key =
            rowUserId > 0
                ? `user-${rowUserId}`
                : `name-${data?.namesec || data?.name || `row-${index}`}`
        const customerNo = customerMap.get(key)
        return customerNo ? `Customer ${customerNo}` : `Customer ${index + 1}`
    }

    const downloadModalFile = async () => {
        if (!showDownloadButton) return

        const productId = bidPopUp.id || search.id
        if (!productId) {
            setAlert(phrase['invalid_product_id'] || 'Invalid product id', 'error')
            return
        }

        const downloadFallbackCsv = () => {
            const escapeCsv = (value) => `"${`${value ?? ''}`.replace(/"/g, '""')}"`
            const rows = [
                ['Username', 'Date Time', 'Amount'],
                ...viewProduct.map((data, index) => [
                    getBidderLabel(data, index),
                    dateTimeFormatFunction(data.created_at),
                    `${data.formattedCurrency || ''}${data.proposed_amount || ''}`,
                ]),
            ]

            const csvContent = '\uFEFF' + rows.map((row) => row.map(escapeCsv).join(',')).join('\n')
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `bidhistory_${productId}_${Date.now()}.csv`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }

        const res = await apiCall('get', `download-bidhistory/${productId}`, '', '', 'product')
        if (res?.data?.status === 'success' && res?.data?.filePath) {
            window.location.href = res.data.filePath
            return
        }
        downloadFallbackCsv()
    }

    return (
        <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open={bidPopUp.popup}
            className={`${classes.modal} customModal`}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={bidPopUp.popup}>
                <div className="bidHistoryModal">
                    <div className={classes.paper}>
                        <div className={`modal fade show custom-modal ${isOutlet ? 'outlet' : ''}`}>
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Bid History</h4>
                                        <Button
                                            className="close"
                                            onClick={() => setBidPopUp({ popup: false, id: 0 })}
                                        >
                                            <span className="material-icons">close</span>
                                        </Button>
                                    </div>
                                    <div className="modal-body cm-body table-responsive">
                                        {showDownloadButton ? (
                                            <div className="d-flex justify-content-end mb-2">
                                                <Button
                                                    className="backBtn"
                                                    onClick={downloadModalFile}
                                                >
                                                    {phrase.download || 'Download'}{' '}
                                                    {phrase.bid_history}{' '}
                                                </Button>
                                            </div>
                                        ) : null}
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{phrase.username}</th>
                                                    <th scope="col">{phrase.date_time}</th>
                                                    <th scope="col">{phrase.amount}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {viewProduct.length > 0
                                                    ? viewProduct.map((data, index) => (
                                                          <tr
                                                              key={`bid-row-${index}-${
                                                                  data.user_id || 'na'
                                                              }`}
                                                          >
                                                              <td>{getBidderLabel(data, index)}</td>
                                                              <td>
                                                                  {dateTimeFormatFunction(
                                                                      data.created_at,
                                                                  )}
                                                              </td>
                                                              <td>
                                                                  {data.formattedCurrency}
                                                                  {data.proposed_amount}
                                                              </td>
                                                          </tr>
                                                      ))
                                                    : null}
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center align-items-center flex-wrap w-100 mb-3 pagination-wrapper">
                                            {viewProduct.length == 0 ? (
                                                <div>{phrase.no_bids_found}</div>
                                            ) : null}
                                            {/* <h6>Showing of {get_allbidhistory.totalRecords}</h6>
                                            <Pagination
                                                count={Math.ceil(
                                                    get_allbidhistory.totalRecords / search.limit,
                                                )}
                                                page={search.page}
                                                onChange={onHandlePage}
                                                siblingCount={3}
                                                showFirstButton
                                                showLastButton
                                                boundaryCount={2}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default BidHistory
